module.exports = __webpack_public_path__ + "static/media/barbecue-pork-fried-rice.ed24dfad.jpg";